import styled from "styled-components";

export const CrossBrandItemIconDefaultBox = styled.div`
  margin: 0 0 2px 0;

  @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
    transform: scale(0.85);
  }
`;
